<template>
  <Icon
    name="card"
    :width="20"
    :height="16"
  >
    <path fill-rule="evenodd" clip-rule="evenodd" d="M18 0H2C0.890015 0 0.0100098 0.889999 0.0100098 2L0 14C0 15.11 0.890015 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.889999 19.11 0 18 0ZM18 14H2V8H18V14ZM2 4H18V2H2V4Z" />
  </Icon>
</template>

<script>
import Icon from "../Elements/Icon";

export default {
  name: 'Card',
  components: { Icon },
};
</script>
